module.exports = __webpack_public_path__ + "static/social-2-3c8cf216b13a814006dc68fe68ee09e6.png";